export const INIT = 'app/DeedsPage/INIT';
export const INIT_SUCCESS = 'app/DeedsPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/DeedsPage/INIT_FAILED';
export const SET_SEARCH = 'app/DeedsPage/SET_SEARCH';
export const SET_TIME = 'app/DeedsPage/SET_TIME';
